import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box, Card, CardContent, Typography, RadioGroup, FormControlLabel,
  Radio, CircularProgress, TextField, Button,
} from "@mui/material";
import { fetchReportFormat, updateReportFormat } from "../../redux/reportSettingsSlice";
import { logger } from "../../utils/logger";

const ReportFormatTab = ({ username, role }) => {
  const dispatch = useDispatch();
  const { format, minYear } = useSelector((state) => state.reportSettings);
  const [saving, setSaving] = useState(false);
  const [minYearInput, setMinYearInput] = useState(minYear);

  useEffect(() => {
    dispatch(fetchReportFormat());
  }, [dispatch]);

  useEffect(() => {
    setMinYearInput(minYear);
  }, [minYear]);

  const handleFormatChange = async (e) => {
    const newFormat = e.target.value;
    setSaving(true);
    try {
      await dispatch(updateReportFormat({ format: newFormat })).unwrap();
      logger.info("Report format changed", { newFormat, username, role });
    } catch (err) {
      logger.error("Error changing report format", { error: err, username, role });
    } finally {
      setSaving(false);
    }
  };

  const handleMinYearSave = async () => {
    setSaving(true);
    try {
      await dispatch(updateReportFormat({ minYear: minYearInput })).unwrap();
      logger.info("Report min year changed", { minYearInput, username, role });
    } catch (err) {
      logger.error("Error changing min year", { error: err, username, role });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ mt: 2, width: "100%" }}>
      <Card sx={{ maxWidth: 500, p: 2 }}>
        <CardContent>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            Bookwise & Summary Report Format
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Choose how the Bookwise and Summary reports display data by default for all users.
          </Typography>

          {saving ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <RadioGroup value={format} onChange={handleFormatChange}>
              <FormControlLabel value="yearFilter" control={<Radio />} label="Year Filter (user selects a specific year)" />
              <FormControlLabel value="yearGrouped" control={<Radio />} label="Year Grouping (all years shown together, auto-grouped)" />
            </RadioGroup>
          )}

          {/* NEW: min year setting for the Year dropdown */}
          <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid #eee" }}>
            <Typography variant="subtitle2" gutterBottom fontWeight="bold">
              Year Dropdown — Earliest Year
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              The Year filter dropdown will list years from this value up to the current year.
            </Typography>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", mt: 1 }}>
              <TextField
                type="number"
                size="small"
                value={minYearInput}
                onChange={(e) => setMinYearInput(e.target.value)}
                sx={{ width: 120 }}
              />
              <Button variant="contained" size="small" onClick={handleMinYearSave} disabled={saving}>
                Save
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReportFormatTab;